import { render, staticRenderFns } from "./IndexFieldList.vue?vue&type=template&id=b5880d5a&scoped=true&"
import script from "./IndexFieldList.vue?vue&type=script&lang=js&"
export * from "./IndexFieldList.vue?vue&type=script&lang=js&"
import style0 from "./IndexFieldList.vue?vue&type=style&index=0&id=b5880d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5880d5a",
  null
  
)

export default component.exports